import axios from 'axios';

export async function getResources() {
    const { data } = await axios.get('/resources');
    return data;
}

export async function getTags() {
    const { data } = await axios.get('/resources/tags');
    return data;
}

export async function createTag(name) {
    const { data } = await axios.post('/resources/tags', { name });
    return data;
}

export async function deleteTag(id) {
    await axios.delete(`/resources/tags/${id}`);
}

export async function saveResource({ id, title, type, tagIds, url, file }) {
    const formData = new FormData();
    if (id != null) formData.append('id', id);
    formData.append('title', title);
    formData.append('type', type);
    formData.append('tagIds', tagIds.join(','));
    if (type === 'url') formData.append('url', url);
    if (type === 'pdf' && file) formData.append('file', file);
    const { data } = await axios.post('/resources', formData);
    return data;
}

export async function deleteResource(id) {
    await axios.delete(`/resources/${id}`);
}

export function downloadResource(id, title) {
    axios({ method: 'get', url: `/resources/${id}/download`, responseType: 'blob' })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${title}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        });
}
